import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { setUser, resetUser, trackPageView } from '@/lib/faro';

export function ObservabilityProvider({ children }: { children: React.ReactNode }) {
    const { user } = useAuth();
    const location = useLocation();
    const prevUserId = useRef<number | null>(null);

    // Identify/reset user when auth state changes
    useEffect(() => {
        if (user && user.id !== prevUserId.current) {
            setUser(String(user.id), {
                email: user.email,
                name: user.display_name,
                role: user.role,
            });
            prevUserId.current = user.id;
        } else if (!user && prevUserId.current !== null) {
            resetUser();
            prevUserId.current = null;
        }
    }, [user]);

    // Track page views on route change
    useEffect(() => {
        trackPageView(location.pathname);
    }, [location.pathname]);

    return <>{children}</>;
}
